import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'scitis-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent implements OnInit {

  @Input()
  disablePageNavigation: boolean = false;
  @Input()
  lastPageReached: boolean = false;
  @Input()
  customItemsPerPageOptions: number[] = [];
  @Output()
  itemsPerPageChanged = new EventEmitter<number>();
  @Output()
  loadPageNumber = new EventEmitter<number>();

  itemsPerPageOptions: number[] = new Array<number>(50, 100, 250);
  itemsPerPage: number = this.itemsPerPageOptions[0];
  currentPageIndex: number = 0;

  private _reset: boolean = false;

  @Input() set reset(value: boolean) {
    this.resetPageIndex(value);
  }

  ngOnInit(): void {
    if (this.customItemsPerPageOptions.length > 0) {
      this.itemsPerPageOptions = this.customItemsPerPageOptions;
      this.itemsPerPage = this.itemsPerPageOptions[this.itemsPerPageOptions.length - 1];
    }
    this.itemsPerPageChanged.emit(this.itemsPerPage);
  }

  onItemsPerPageChange(): void {
    this.currentPageIndex = 0;
    this.itemsPerPageChanged.emit(this.itemsPerPage);
  }

  public onLoadNextPage(): void {
    if (this.disablePageNavigation) {
      return;
    }

    this.currentPageIndex++;
    this.loadPageNumber.emit(this.currentPageIndex);
  }

  public onLoadPreviousPage(): void {
    if (this.disablePageNavigation) {
      return;
    }

    if (this.currentPageIndex > 0) {
      this.currentPageIndex = this.currentPageIndex - 1;
      this.loadPageNumber.emit(this.currentPageIndex);
    }
  }

  private resetPageIndex(reset: boolean) {
    this._reset = reset;
    if (reset) {
      this.currentPageIndex = 0;
    }
  }
}
